import type { FC, ReactNode } from "react";

import type { ContentGateProps } from "../ContentGate";
import { ContentGatePopup } from "../ContentGatePopup";

import { useContentGateIPRestrictions } from "./hooks/useContentGateIPRestrictions";

export interface ContentGateIPProps extends Omit<ContentGateProps, "restrictions"> {
  externalContent?: ReactNode;
  restriction: string;
  countriesApiUrl?: string;
}

export const ContentGateIP: FC<ContentGateIPProps> = ({
  externalContent,
  languages,
  logoSrc,
  title,
  whyContentRestricted,
  restriction,
  countriesApiUrl,
}) => {
  const { activeRestrictions } = useContentGateIPRestrictions(restriction, countriesApiUrl);

  return (
    <ContentGatePopup
      externalContent={externalContent}
      title={title}
      logoSrc={logoSrc}
      languages={languages}
      whyContentRestricted={whyContentRestricted}
      restrictions={activeRestrictions}
      isOpen={!!activeRestrictions.length}
    />
  );
};
